"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickBuyColor = void 0;
const getQuickBuyColor = ({
  disabled,
  theme
}) => {
  if (disabled) {
    return theme.palette.action.disabled;
  }
  return theme.palette.text.primary;
};
exports.getQuickBuyColor = getQuickBuyColor;
//# sourceMappingURL=helpers.js.map